import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './redux/store'
import { Provider } from 'react-redux'

// Global handler for unhandled promise rejections
// Suppress errors that are already handled by axios interceptors (e.g., 401 errors)
const handleUnhandledRejection = (event) => {
  const error = event.reason;
  
  if (!error) {
    return;
  }
  
  // Check if error is marked as handled (401 that triggered logout)
  const isHandled = error.isHandled || error._isHandled401;
  
  // Check if it's a 401 AxiosError
  const is401AxiosError = error.isAxiosError && 
                          error.response && 
                          error.response.status === 401;
  
  // Check if it's a 401 error by status code
  const is401Error = (error.response && error.response.status === 401) || 
                     error.status === 401;
  
  // Check error message for 401 indicators
  const errorMessage = error.message || error.toString() || '';
  const is401Message = errorMessage.includes('401') || 
                       errorMessage.includes('Unauthorized') ||
                       errorMessage.includes('Request failed with status code 401');
  
  // Suppress 401 errors - they're handled by the axios interceptor
  if (isHandled || is401AxiosError || is401Error || is401Message) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    // Suppress the error completely
    return false;
  }
};

// Add event listener with capture phase to catch early
window.addEventListener('unhandledrejection', handleUnhandledRejection, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Provider store={store} >
    <App />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
